import { render, staticRenderFns } from "./CardP.vue?vue&type=template&id=2c52d0d4&scoped=true&"
import script from "./CardP.vue?vue&type=script&lang=js&"
export * from "./CardP.vue?vue&type=script&lang=js&"
import style0 from "./CardP.vue?vue&type=style&index=0&id=2c52d0d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c52d0d4",
  null
  
)

export default component.exports